// Tags only. Shared table methods are in tableMixin.js.
import axios from "axios";

export default {
    name: "Tags",
    methods: {
        clearForm() {
            this.isSaving = false;
            this.isEditing = false;
            this.submitted = false;
            this.formInputs = this.getDefaultFormInputs();
            this.defaultAlert = this.getDefaultAlert();
            this.$clearValidationStates("#recordForm");
        },
        // × on the Module label
        removePageFilterChip(key) {
            if (key === "modules") this.tableData.modules = [];
        },
        // Delete window text: warn how many records use the tag
        deleteMessageFor(record) {
            if (this.tableData.deleteType === "permanent" && record.used_count) {
                return `${this.deleteModalMessage} It is used on ${record.used_count} record(s) and will be removed from them.`;
            }
            if (this.tableData.deleteType === "soft" && record.used_count) {
                return `${this.deleteModalMessage} It will be hidden on ${record.used_count} record(s) until restored.`;
            }
            return this.deleteModalMessage;
        },
        // "Delete Selected": same as tableMixin's, but warns that tags disappear from their records
        deleteSelectedRecords() {
            const ids = this.tableData.selectedRecordIds;
            if (!ids.length) return;
            if (!confirm(`Are you sure you want to delete ${ids.length} tag(s)? They will be hidden on their records until restored.`)) return;

            this.$showOrHideLoader(this.$loaderMessages.deleting);
            const data = { action: "deleteRecord", ids, deleteType: "soft" };

            axios
                .delete(this.apiUrl, this.$handleConfig(data))
                .then((response) => {
                    if (response.data.status === "success") {
                        this.handleAlert("ending", response.data.message, "success", "page");
                        this.tableData.selectedRecordIds = [];
                        this.tableData.selectAll = false;
                        this.fetchRecords();
                    } else {
                        this.tableData.isVisible = false;
                        this.handleError("ending", response.data.message, "danger", "page");
                    }
                })
                .catch((error) => this.handleRequestError(error, "page"));
        },
    },
};